import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

import { TranslateModule } from '@ngx-translate/core';

import { MgButtonModule } from '@app/src/app/button';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { GenericModule } from '@shared/components/generic';

import { PasswordComponent } from './Password.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgSpinnerModule,
    MgIconModule,
    MgFormFieldModule,
    MgButtonModule,
    GenericModule,

    // External dependencies
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    CommonModule,
    TranslateModule,
  ],
  declarations: [PasswordComponent],
  exports: [PasswordComponent],
})
export class MgPasswordModule {}
